module.exports = __webpack_public_path__ + "img/logo_original_fundo_transparente.40889119.png";